module.exports = __WEBPACK_EXTERNAL_MODULE_39__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/errors/IllegalOperationError","root":["openfl","errors","IllegalOperationError"],"commonjs":"openfl/errors/IllegalOperationError","commonjs2":"openfl/errors/IllegalOperationError"}
// module id = 39
// module chunks = 0